import {getUser} from './website-ui/repositories/user-memory-repository';

const user = getUser();

if (user.isAuthenticated) {
  window.location.href = '/profile';
}
